export let exportMenu = [
	{
		icon: "uil-clipboard-notes sidebar-icon",
		children: [
			{
				title: true,
				i18n: "documents",
			},
			{
				url: "/production-board",
				i18n: "production_board",
				icon: "uil-apps",
			},
			{
				url: "/documents-in",
				i18n: "good_reception",
				icon: "uil-bring-front",
			},
			{
				url: "/documents-preparation",
				i18n: "preparation",
				icon: "uil-apps",
				permission: "documents_preparation",
				active: false,
			},
			{
				url: "/write-off",
				i18n: "write_off",
				icon: "uil-trash-alt",
				permission: "documents_write_off",
				active: false,
			},
			{
				url: "/inventory",
				i18n: "inventory",
				icon: "uil-clipboard-alt",
				active: false,
			},
			{
				title: true,
				i18n: "reports",
			},
			{
				url: "/report/dashboard",
				i18n: "home",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/summary",
				i18n: "summary_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/shifts",
				i18n: "shifts",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/z-report",
				i18n: "z_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-in",
				i18n: "good_reception",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-preparation",
				i18n: "preparation",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/sales",
				i18n: "sales",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/cashiers",
				i18n: "cashiers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/expenses",
				i18n: "income_expense",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/rasxodlar",
				i18n: "expenses_by_worker",
				icon: "uil-money-bill",
			},
			{
				url: "/report/gross-income",
				i18n: "gross_income",
				icon: "uil-chart-pie-alt",
				permission: "report_gross_income",
				active: false,
			},
			{
				url: "/cashbox/pending-orders",
				i18n: "pending_orders",
				icon: "uil-clock",
				active: false,
			},
			{
				url: "/report/returns",
				i18n: "returns_report",
				icon: "uil-redo",
			},
			{
				url: "/report/deleted-cheques",
				i18n: "deleted_cheques",
				icon: "uil-trash-alt",
			},
			{
				url: "/report/deleted-expenses",
				i18n: "deleted_expenses",
				icon: "uil-receipt-alt",
			},
			{
				title: true,
				i18n: "debit_credit",
			},
			{
				url: "/report-suppliers",
				i18n: "suppliers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-clients",
				i18n: "clients",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/debt-monitoring",
				i18n: "debt_monitoring",
				icon: "uil-clock-three",
			},
			{
				title: true,
				i18n: "warehouses",
			},
			{
				url: "/report-balance",
				i18n: "balance2",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-balance-2",
				i18n: "balance_by_category",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/warehouse-rolls",
				i18n: "warehouse_rolls",
				icon: "uil-archive",
			},
			{
				url: "/warehouse-products",
				i18n: "warehouse_products",
				icon: "uil-archive",
			},
			{
				url: "/warehouse-finished",
				i18n: "warehouse_finished",
				icon: "uil-archive",
			},

		]
	},
	{
		icon: "uil-chart-bar sidebar-icon",
		children: [
			{
				title: true,
				i18n: "analytics",
			},
			{
				url: "/analytics/dashboard",
				i18n: "analytics_dashboard",
				icon: "uil-chart-pie-alt",
				active: false,
			},
			{
				url: "/analytics/customer",
				i18n: "customer_analytics",
				icon: "uil-users-alt",
				active: false,
			},
			{
				url: "/analytics/unit",
				i18n: "unit_dashboard",
				icon: "uil-building",
				active: false,
			},
			{
				url: "/analytics/expenses",
				i18n: "expense_dashboard",
				icon: "uil-invoice",
				active: false,
			},
			{
				url: "/analytics/monthly-report",
				i18n: "monthly_report",
				icon: "uil-file-alt",
				active: false,
			},
			{
				url: "/analytics/reorder",
				i18n: "reorder_title",
				icon: "uil-shopping-cart-alt",
				active: false,
			},
			{
				url: "/analytics/abc-products",
				i18n: "abc_products",
				icon: "uil-cell",
				active: false,
			},
			{
				url: "/analytics/frozen",
				i18n: "frozen_title",
				icon: "uil-snowflake",
				active: false,
			},
			{
				url: "/analytics/abc-xyz",
				i18n: "abc_xyz_title",
				icon: "uil-apps",
				active: false,
			},
			{
				url: "/analytics/daily-dashboard",
				i18n: "daily_dashboard",
				icon: "uil-layer-group",
				active: false,
			},
			{
				url: "/report/roll-profit",
				i18n: "roll_profit",
				icon: "uil-layer-group",
				active: false,
			},
			{
				url: "/report/roll-prices",
				i18n: "roll_prices",
				icon: "uil-chart-line",
				active: false,
			},
		]
	},
	{
		icon: "uil-users-alt sidebar-icon",
		children: [
			{
				title: true,
				i18n: "employees",
			},
			{
				url: "/employees",
				i18n: "employees",
				icon: "uil-users-alt",
			},
			{
				url: "/employee-account",
				i18n: "employee_account",
				icon: "uil-transaction",
			},
			{
				url: "/kpi",
				i18n: "kpi",
				icon: "uil-chart-line",
			},
			{
				url: "/attendance",
				i18n: "attendance",
				icon: "uil-calendar-alt",
			},
			{
				url: "/employees-types",
				i18n: "positions",
				icon: "uil-list-ui-alt",
			},
			{
				url: "/departments",
				i18n: "departments",
				icon: "uil-web-grid-alt",
			},
		]
	},
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "settings",
			},
			{
				url: "/pos",
				i18n: "pos",
				icon: "uil-shop",
				active: false,
			},
			{
				url: "/products",
				i18n: "products",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				url: "/production-capacity",
				i18n: "production_capacity",
				icon: "uil-tachometer-fast-alt",
				active: false,
			},
			{
				url: "/product-statuses",
				i18n: "product_statuses",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				url: "/wms",
				i18n: "warehouse",
				icon: "uil-store",
				active: false,
			},
			{
				url: "/clients",
				i18n: "clients",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/clients-types",
				i18n: "client_types",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/regions",
				i18n: "regions",
				icon: "uil-map-marker",
				active: false,
			},
			{
				url: "/units",
				i18n: "units",
				icon: "uil-cell",
			},
			{
				url: "/payment-types",
				i18n: "payment_types",
				icon: "uil-transaction",
				permission: "payment_types",
				active: false,
			},
			{
				url: "/payment-purposes",
				i18n: "income_expense",
				icon: "uil-coins",
			},
			{
				url: "/categories",
				i18n: "categories",
				icon: "uil-web-section-alt",
			},
			{
				url: "/delivery-types",
				i18n: "delivery_type",
				icon: "uil-truck",
			},
			{
				url: "/suppliers",
				i18n: "suppliers",
				icon: "uil-truck-loading",
			},
			{
				url: "/currency",
				i18n: "currency",
				icon: "uil-transaction",
			},
			{
				url: "/accounts",
				i18n: "accounts",
				icon: "uil-moneybag",
			},
			{
				url: "/cheque-note-settings",
				i18n: "cheque_note_settings",
				icon: "uil-receipt-alt",
			},
		]
	},
	{
		icon: "uil-plug sidebar-icon",
		children: [
			{
				title: true,
				i18n: "external_services",
			},
			{
				url: "/telegram-settings",
				i18n: "telegram_settings",
				icon: "uil-telegram",
			},
			{
				url: "/crm-settings",
				i18n: "crm_integration",
				icon: "uil-database-alt",
			},
		]
	},
]